// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"PageTitle_pageTitle__30DXd","title":"PageTitle_title__1RYCP","button":"PageTitle_button__2tEM_","stopSpan":"PageTitle_stopSpan__1PYiG"};